import { registerLicense } from '@syncfusion/ej2-base';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import Loader from './components/loader/Loader';
import { persistor, store } from './redux/Store';
import reportWebVitals from './reportWebVitals';

registerLicense(process.env.REACT_APP_SYNCFUSION_LICENSE_KEY!);

const queryParameters = new URLSearchParams(window.location.search);
let docId = queryParameters.get('docId');
if (docId == null) {
  docId = sessionStorage.getItem('docId');
  sessionStorage.setItem('viewReportInstalled', 'false');
  sessionStorage.setItem('IsCalledFromMfiles', 'false');
} else {
  sessionStorage.setItem('docId', docId!);
  sessionStorage.setItem('viewReportInstalled', 'true');
  sessionStorage.setItem('IsCalledFromMfiles', 'true');
}

let fileId = queryParameters.get('fileId');
if (fileId == null) {
  fileId = sessionStorage.getItem('fileId');
} else sessionStorage.setItem('fileId', fileId!);

let host = queryParameters.get('host');
if (host == null) {
  host = sessionStorage.getItem('host');
} else sessionStorage.setItem('host', host!);

let vaultId = queryParameters.get('vault');
if (vaultId == null) {
  vaultId = sessionStorage.getItem('vaultId');
} else sessionStorage.setItem('vaultId', vaultId!);

let vaultName = queryParameters.get('vName');
//console.log(vaultName);
if (vaultName == null) {
  vaultName = sessionStorage.getItem('vaultName');
} else sessionStorage.setItem('vaultName', vaultName!);

let fileName = queryParameters.get('fileName');
if (fileName == null) {
  fileName = sessionStorage.getItem('fileName');
} else sessionStorage.setItem('fileName', fileName!);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
